import { withProps } from 'recompose'
import Logo from '../Logo/Logo'

const NeuroLexLogo = withProps({
  source: 'https://www.neurolex.ai/img/logo.png',
  companyName: 'NeuroLex'
})(Logo)

export default NeuroLexLogo
